<template>
  <div class="serviceMain">
    <div class="searchBar">
      <div class="tittle"> 挂卖管理 </div>
      <div class="rightForm">
        <el-input
          v-model="form.subject"
          placeholder="请输入作品名称"
        ></el-input>
        <el-date-picker
          v-model="form.date"
           value-format="yyyy-MM-dd"
          type="date"
          placeholder="选择日期"
        >
        </el-date-picker>
        <el-button @click="fetchData">查询</el-button>
        <router-link :to="{path:'/OnSale/InputForm'}">
            <el-button type="primary">新增挂卖</el-button>
        </router-link>
      </div>
    </div>

    <el-table
      :data="tableData"
      :cell-class-name="tabelCellClass"
      style="width: 100%"
      @row-click="onTabelRowClick"
    >
      <el-table-column
        prop="subject"
        label="标题"
        width="180"
         show-overflow-tooltip
      >
      </el-table-column>
      <!-- <el-table-column
        prop="orderNo"
        label="订单号"
        width="180"
      >
      </el-table-column> -->
      <el-table-column
        prop="author"
        label="作者"
        width="150"
      >
      </el-table-column>
      <el-table-column
        prop="price"
        label="挂卖金额(元)"
        width="120"
      >
      </el-table-column>
       <!-- <el-table-column
        prop="num"
        label="交易次数"
        width="120"
      >
      </el-table-column> -->
      <el-table-column
        prop="createTimeText"
        label="创建时间"
        sortable
        width="200"
      >
        <!-- eslint-disable-next-line -->
       <template slot="header" slot-scope="scope">
          <div class="createTimeHeader">
            <span>创建时间</span>
            <a-tooltip>
              <template slot="title">
                prompt text
              </template>
              <a-icon type="question-circle" />
            </a-tooltip>
          </div>
        </template>
      </el-table-column>
       <el-table-column
        prop="status"
        label="状态"
        width="150"
      >
        <template slot-scope="scope">
          <span
            class="stausCell"
            :class="{'stausCell1':scope.row.status=='2','stausCell2':scope.row.status=='0','stausCell3':scope.row.status=='1'}"
          >
            {{scope.row.statusText}}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        width="120"
        fixed="right"
        align="right"
      >
        <template slot-scope="scope">
          <el-button v-if="scope.row.status=='1'" type="text" @click.stop="onStop(scope.row.goodsId)">停止挂卖</el-button>  
          <el-button v-if="scope.row.status=='2'" type="text" @click.stop="onEdit(scope.row)">编辑</el-button>  
          <el-button v-if="scope.row.status=='0'" disabled type="text" @click.stop="onEdit(scope.row)">编辑</el-button>
          <a-icon type="right" class="ml12 gray" />
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="prev, pager, next"
       :total="pagination.total"
      :current-page.sync="pagination.page"
      :page-size.sync="pagination.pageSize"
      @size-change="sizeChange"
      @current-change="currentChange"
    >
    </el-pagination>

  </div>
</template>

<script>
import {queryUserProducts} from '@/api/ObtainEvidence'
import {offShelfGood} from '@/api/EvidenceService'
import { Message, MessageBox } from 'element-ui'
export default {
  name: 'OnSaleList',
 components:{},
  data () {
    return {
      form: {
         subject: null,
        date: null
      },
      pagination: {
        page: 1,
        pageSize: 10,
        total:0
      },
      productFilter:{
        categoryId:null,
        search:null,
        productType:null,
        goodsStatus:null,
      },
       tableData: [
        //  {
        //   subject: '《鄂菜大全》《鄂菜大全》《鄂菜大全》',
        //   orderNo: '109000990099998',
        //   price: '333',
        //   num:'2',
        //   createTimeText: '2019-12-23 14:07',
        //   status: 2, // 1、红色  2、灰色  3、绿色
        //   statusText: "未拍卖",
        // },
      ]
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
 onTabelRowClick(row){
      this.$router.push({
       path:'/OnSale/ListDetail',
       query:{'detailType':'1'}
      });
    },
    tabelCellClass ({ row, column, rowIndex, columnIndex }) {
      if (column.property == 'certificate') {
        return 'certificateCell'
      }
    },
    fetchData (param) {
      queryUserProducts(this.pagination.page,this.pagination.pageSize,this.productFilter).then(({data})=>{
          console.log("挂卖管理：",data);
          let list = [];
          for(let i=0;i<data.list.length;i++){
            let goodsStatus = data.list[i].goods.goodsStatus
            let statusText = ''
            if(goodsStatus == "0"){
              statusText = "已删除"
            }else if(goodsStatus == "1"){
              statusText = "已上架"
            }else if(goodsStatus == "2"){
              statusText = "已下架"
            }
            list.push(
              {
                subject: data.list[i].goods.fullname,
                author: data.list[i].goods.author,
                price: data.list[i].goods.price,
                // num:'2',
                createTimeText: this.dayjs(data.list[i].createTime * 1000).format("YYYY-MM-DD HH:mm:ss "),
                status: data.list[i].goods.goodsStatus, // 1、上架 绿色；2、下架 红色；0、删除 灰色；
                statusText: statusText,
                goodsId: data.list[i].goods.goodsId,
              }
            )
          }
          this.tableData=list;
          this.pagination.total=data.total*1;
        });
    },
    onEdit(){
      this.$router.push({
       path:'/OnSale/InputForm',
       query:{'orderNo':'133fs'}
      });
    },
    onStop(goodsId){
      this.$confirm('确定下架该商品吗, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
          offShelfGood(goodsId, 2 ).then(({ data }) => {
            // 下架商品
            // console.log(data);
            this.fetchData();
            this.$message({
              type: 'success',
              message: '下架成功!'
            });
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消下架'
          });
        });
    },
    sizeChange (pageSize) {
      this.pageSize = pageSize
      this.pageNum = 1
      this.fetchData()
    },
    currentChange (pageNum) {
      // 更新表格数据
      this.fetchData()
    },
  }
}
</script>

<style lang='scss' scoped>
@import '../../../../assets/css/mine.scss';
</style>
